module.exports = __webpack_public_path__ + "img/page-404-image.a07b14eb.png";